import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PersonIcon, ResourceIcon, Sparkle, WorkBuildingIcon } from 'app/components/shared/icons';
import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import { pageSelector, setPage } from 'store/reducers/bd-100/bd-100-reducer';

import { BD100_PAGES, BD100Pages } from '..';
import {
  BD100NavbarContainer,
  BD100NavbarItem,
  BD100NavbarItemsContainer,
  BD100NavbarWrapper,
} from './styled';

interface BD100NavbarProps {
  policiesAccepted: boolean | null;
  onOpportunityClick: () => void;
}

export default function BD100Navbar({ policiesAccepted, onOpportunityClick }: BD100NavbarProps) {
  const dispatch = useDispatch();
  const currentPage = useSelector(pageSelector);
  const putBd100TabClicked = useBehavioral(BEHAVIORALS.BD100_TAB_CLICKED);

  const handlePageClick = (page: BD100Pages) => {
    if (currentPage === page) {
      return;
    }

    if (page === BD100_PAGES.OPPORTUNITIES && policiesAccepted === false) {
      onOpportunityClick();
      return;
    }

    putBd100TabClicked({ action_details: page });
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    window.history.pushState({}, '', url.toString());
    window.scrollTo(0, 0);
    dispatch(setPage(page));
  };

  return (
    <BD100NavbarWrapper>
      <BD100NavbarContainer>
        <BD100NavbarItemsContainer>
          <BD100NavbarItem
            current={currentPage === BD100_PAGES.OPPORTUNITIES}
            onClick={() => handlePageClick(BD100_PAGES.OPPORTUNITIES)}
          >
            <Sparkle
              width={24}
              height={24}
              fill={currentPage === BD100_PAGES.OPPORTUNITIES ? '#171C33' : 'rgba(31, 32, 37, 0.5)'}
            />
            Opportunity Dashboard
          </BD100NavbarItem>
          <BD100NavbarItem
            current={currentPage === BD100_PAGES.SME_COUNCILS}
            onClick={() => handlePageClick(BD100_PAGES.SME_COUNCILS)}
          >
            <WorkBuildingIcon
              width={24}
              height={24}
              fill={currentPage === BD100_PAGES.SME_COUNCILS ? '#171C33' : 'rgba(31, 32, 37, 0.5)'}
            />
            SME Councils
          </BD100NavbarItem>
          <BD100NavbarItem
            current={currentPage === BD100_PAGES.RESOURCE_LIBRARY}
            onClick={() => handlePageClick(BD100_PAGES.RESOURCE_LIBRARY)}
          >
            <ResourceIcon
              width={24}
              height={24}
              fill={
                currentPage === BD100_PAGES.RESOURCE_LIBRARY ? '#171C33' : 'rgba(31, 32, 37, 0.5)'
              }
            />
            Resource Library
          </BD100NavbarItem>
          <BD100NavbarItem
            current={currentPage === BD100_PAGES.TEAMING}
            onClick={() => handlePageClick(BD100_PAGES.TEAMING)}
          >
            <PersonIcon
              width={24}
              height={24}
              fill={currentPage === BD100_PAGES.TEAMING ? '#171C33' : 'rgba(31, 32, 37, 0.5)'}
            />
            Teaming
          </BD100NavbarItem>
        </BD100NavbarItemsContainer>
      </BD100NavbarContainer>
    </BD100NavbarWrapper>
  );
}
